import React from "react";
import { useParams } from "react-router-dom";
import OfficeUpdateMembershipForm from "../../Components/OfficeUpdateMembershipForm";

const OfficeUpdateForm = () => {
  const { step } = useParams();
  const renderComp = () => {
    switch (step) {
      case "membership-form":
        return <OfficeUpdateMembershipForm />;
      default:
        return <OfficeUpdateMembershipForm />;
    }
  };
  return <>{renderComp()}</>;
};

export default OfficeUpdateForm;
